import React from 'react';


class Quote extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let align = this.props.align ? 'align-items-end' : '';
        return (
            <section className="mole__project--quote fullW">
                <div className="main-container">
                    <div className={`inner-container font-md d-flex flex-column ${align}`}>
                        <article>
                            <blockquote className="c-general mb-0">
                                <q dangerouslySetInnerHTML= {{__html:this.props.quote}}></q>
                            </blockquote>
                            <div className="blockquote-author">
                                {this.props.author}
                            </div>
                        </article>
                    </div>
                </div>
            </section>
        );
    }
}
export default Quote;



// WEBPACK FOOTER //
// ./src/components/Projects/Details/Quote.js